<template>
  <EditorNodeWrapper class="pricing-summary-container">
    <div
      v-for="([, { tables, totalValue }], index) in pricingTablesGroupedByCurrency"
      :key="index"
      class="summary-group"
    >
      <div class="header-row">
        <div class="name-column">Name</div>
        <div class="price-column">Value</div>
      </div>
      <div v-for="table in tables" :key="table.id" class="row">
        <div class="name-column">{{ table.name || 'Untitled' }}</div>
        <div class="price-column">
          {{ currencyFormat(table.value, table.currencySettings) }}
        </div>
      </div>
      <div class="summary-container">
        <div class="value-label">Total value:</div>
        <div class="value">{{ currencyFormat(totalValue, tables[0].currencySettings) }}</div>
      </div>
    </div>
  </EditorNodeWrapper>
</template>
<script lang="ts">
import { PricingSummaryHelper, PricingTableHelper, type Context, type PricingSummary } from '@getaccept/editor-lib-new';
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { EditorRecipientInput } from '@getaccept/lib-shared-new/src/types/editor-recipient-input';
import { storeToRefs } from 'pinia';
import { useEditorViewContentStore } from '../store/editor-view-content.store';
import EditorNodeWrapper from './EditorNodeWrapper.vue';

export default defineComponent({
  components: {
    EditorNodeWrapper,
  },
  props: {
    node: {
      type: Object as PropType<PricingSummary>,
      required: true,
    },
    context: { type: String as PropType<Context>, required: true },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, required: true },
  },
  setup(props) {
    const editorViewContentStore = useEditorViewContentStore();
    const { allPricingTables } = storeToRefs(editorViewContentStore);

    const pricingTablesGroupedByCurrency = computed(() =>
      PricingSummaryHelper.pricingTablesGroupedByCurrency(
        allPricingTables.value,
        props.recipientInput
      )
    );

    return {
      currencyFormat: PricingTableHelper.currencyFormat,
      pricingTablesGroupedByCurrency,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/editor-lib-new/src/scss/editor-node-pricing-summary';
</style>
